import { render, staticRenderFns } from "./MoveInPaymentDetails.vue?vue&type=template&id=1a908510&lang=true"
import script from "./MoveInPaymentDetails.vue?vue&type=script&lang=js"
export * from "./MoveInPaymentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports